const initialState = {
    ts_drive_distance_component_content_data: null,
    ts_NBA_extend_component_content_data: null,
    ts_NBA_use_component_content_data: null,
    ts_NBA_extend_use_component_content_data: null,
    ts_NBA_upgrade_component_content_data: null,
    ts_aspot_component_content_data: null,
    ts_trip_leads_regions_names_data: null,
    ts_aspot_generic_component_content: null,
    arn_hotel_data: null,
}
export default function DashboardReducer(state = initialState, action) {
    switch (action.type) {
        case "TS_DRIVE_COMPONENT_CONTENT":
            return {
                ...state,
                ts_drive_distance_component_content_data: action.data
            }
        case "TS_C_SPOT_NBA_COMPONENT_CONTENT":
            return {
                ...state,
                ts_c_spot_NBA_component_content_data: action.data
            }
        case "TS_ASPOT_COMPONENT_CONTENT":
            return {
                ...state,
                ts_aspot_component_content_data: action.data
            }
        case "TS_TRIP_LEADS_REGION_NAMES":
            return {
                ...state,
                ts_trip_leads_regions_names_data: action.data
            }
        case "TS_ASPOT_GENERIC_COMPONENT_CONTENT":
            return {
                ...state,
                ts_aspot_generic_component_content: action.data
            }
        case "ARN_HOTEL_DATA":
            return {
                ...state,
                arn_hotel_data: action.data

            }
        default:
            return {
                ...state
            }
    }

}

